import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { getIsLoggedInSelector } from '@americanexpress/travel-selectors';
import { withConditionalFeatures } from '@americanexpress/conditional-features';
import TravelBenefits from '../TravelBenefits/TravelBenefits';
import style from './CardOffers.scss';
import { GUEST } from '../../constants/cardTypeConstants';
import { hasMyTravelBenefitsRule } from '../../constants/featureRulesConstants';
import { getSelectedAccount } from '../../utils/travelerDataUtils';
import BottomTiles from '../CardOffersTiles/BottomTiles';
import DesktopSideTiles from '../CardOffersTiles/DesktopSideTiles';
import SideTiles from '../CardOffersTiles/SideTiles';
import LargeTile from '../CardOffersTiles/LargeTile';

const CardOffers = ({
  cardOffersData,
  cardType,
  hasMyTravelBenefits,
  hasTravelerError,
  isLoggedIn,
  travelerData,
}) => {
  const { cards, carousel, benefits } = cardOffersData;
  const [topColumnTile, bottomColumnTile, leftRowTile, rightRowTile] = cards;

  const showTravelBenefits = isLoggedIn
    && hasMyTravelBenefits
    && !hasTravelerError
    && travelerData
    && !!benefits;

  const selectedAccountData = getSelectedAccount(travelerData);

  return (
    <div className="row margin-0-lr-md-down">
      <div className="col-lg-9 pad-2-r-lg-up margin-4-t-md-down">
        <div className="row">
          {
            showTravelBenefits
            && (
              <div className={`${style.travelBenefits} col-lg-4 col-md-6 margin-4-t margin-4-b pad-2-lr-sm-down pad-3-l-md-up pad-1-r-lg-up pad-2-l-lg-up`}>
                <TravelBenefits
                  travelBenefits={benefits}
                  travelerData={travelerData}
                  selectedAccountData={selectedAccountData}
                />
              </div>
            )
          }
          <div className={clsx(
            'margin-4-b pad-2-r-lg-up',
            style.carousel,
            showTravelBenefits
              ? 'col-lg-8 col-md-6 margin-4-t-md-up pad-0-l pad-0-r-sm-down pad-3-r-md-up'
              : 'col margin-3-t-lg-up pad-2-lr-sm-down pad-3-lr-md-up pad-2-l-lg-up')}
          >
            <LargeTile
              showTravelBenefits={showTravelBenefits}
              carousel={carousel}
              selectedAccountData={selectedAccountData}
            />
          </div>
        </div>
        <div className="row hidden-lg-up">
          <SideTiles
            topColumnTile={topColumnTile}
            bottomColumnTile={bottomColumnTile}
            cardType={cardType}
          />
        </div>
        <BottomTiles leftRowTile={leftRowTile} rightRowTile={rightRowTile} cardType={cardType} />
      </div>
      <div id="desktopSideTiles" className={clsx('col-lg-3 hidden-md-down', showTravelBenefits ? 'margin-4-t' : 'margin-3-t')}>
        <DesktopSideTiles
          topColumnTile={topColumnTile}
          bottomColumnTile={bottomColumnTile}
          cardType={cardType}
        />
      </div>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  isLoggedIn: getIsLoggedInSelector,
});

const mapFeaturesToProps = {
  hasMyTravelBenefits: hasMyTravelBenefitsRule,
};

const hocChain = compose(
  withConditionalFeatures({ mapFeaturesToProps }),
  connect(mapStateToProps)
);

CardOffers.propTypes = {
  cardOffersData: PropTypes.shape({
    cards: PropTypes.arrayOf(PropTypes.shape({})),
    carousel: PropTypes.arrayOf(PropTypes.shape({})),
    benefits: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  cardType: PropTypes.string,
  hasMyTravelBenefits: PropTypes.bool,
  hasTravelerError: PropTypes.bool.isRequired,
  travelerData: PropTypes.shape({
    card: PropTypes.shape({
      type: PropTypes.string,
    }),
    loyalty: PropTypes.shape({}),
  }),
  isLoggedIn: PropTypes.bool.isRequired,
};

CardOffers.defaultProps = {
  cardOffersData: {},
  cardType: GUEST,
  hasMyTravelBenefits: false,
};

export { CardOffers as TestableCardOffers };

export default hocChain(CardOffers);
